/**
 * The button glyphs the redesign draws itself, on a 16×16 grid at stroke 1.5 —
 * the same hand as `GaiaDeleteButton`'s trash and ✕, and deliberately not the
 * icon vocabulary in `./icons` (when this was written `AddOutline`, `Add`,
 * `PlusOutlined` and ten hand-rolled copies were all in use for the plus alone,
 * at three sizes, two viewBoxes and four stroke widths; `./icons` has since
 * settled the packs down to one, but these paths stay hand-drawn because they
 * sit inside the redesign's own buttons and are cut to their 16×16 grid).
 *
 * Only the path lives here. Each button renders its own `<svg>` wrapper, as
 * `GaiaDeleteButton` does — the wrapper is four stable attributes and keeping
 * it inline lets a component be read on its own. The path is what drifted.
 */
export const gaiaGlyphPaths = {
  /** ＋ — shared by `GaiaCreateButton` and `GaiaAddButton`. */
  plus: 'M8 3v10M3 8h10',
  /** ↥ — `GaiaUploadButton`. An arrow leaving the machine, not a plus. */
  upload: 'M8 10V3M4.8 6 8 2.8 11.2 6M3 13h10',
  /** ✎ — a row's edit icon button, beside `GaiaDeleteButton`'s trash. */
  edit: 'M11.2 2.6 13.4 4.8 5.6 12.6 2.6 13.4l.8-3z',
} as const;

/** Glyph edge in px per button size step — 12/13/14 beside tiny/small/medium. */
export const gaiaGlyphSize = {
  xs: 12,
  sm: 13,
  md: 14,
} as const;
